import React, { ReactNode, useEffect, useRef } from "react";
import { flexCentering, GraySpinner } from "goi_common";

import Script from "next/script";
import styled from "@emotion/styled";
import { useRecoilState } from "recoil";
import { isMapLoadState } from "../atoms/mapState";

interface Map {
  children: ReactNode;
}

function HospiceMapLayout({
  latitude,
  longitude,
}: {
  latitude: number;
  longitude: number;
}) {
  const [isLoad, setIsLoad] = useRecoilState(isMapLoadState);
  const mapRef = useRef() as React.MutableRefObject<HTMLDivElement>;
  useEffect(() => {
    if (!isLoad || !mapRef) return;

    const mapOptions = {
      center: new window.naver.maps.LatLng(latitude, longitude),
      zoom: 14,
      draggable: false,
    };
    const map = new window.naver.maps.Map(mapRef.current, mapOptions);
    const markerOptions = {
      position: new window.naver.maps.LatLng(latitude, longitude),
      map,
      icon: {
        content:
          "<img src='/icons/icon-pin-location-mono.svg' alt='장지' style='min-width: 44px; min-height: 44px'/>",
        scaledSize: new window.naver.maps.Size(44, 44),
        origin: new window.naver.maps.Point(22, 22),
        anchor: new window.naver.maps.Point(22, 22),
      },
    };

    //eslint-disable-next-line
    const marker = new window.naver.maps.Marker(markerOptions);

    return () => map.destroy();
  }, [isLoad, latitude, longitude]);

  return (
    <>
      <Script
        src={`https://openapi.map.naver.com/openapi/v3/maps.js?ncpClientId=${process.env.NEXT_PUBLIC_NAVERMAP_KEY}`}
        onLoad={() => setIsLoad(true)}
      />
      <MapLayoutRoot id="mapLayout">
        <Map ref={mapRef}>{!isLoad && <GraySpinner />}</Map>
      </MapLayoutRoot>
    </>
  );
}

const MapLayoutRoot = styled.div`
  position: relative;
  height: 220px;
  width: 100%;
`;

const Map = styled.div`
  ${flexCentering("row")}
  height: 220px;
  width: 100%;
  outline: none;
`;

export default HospiceMapLayout;
